














import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import ProgressItem from '@/trials/views/components/ProgressItem.vue';

@Component({ components: { ProgressItem } })
export default class TrainDataGettingKcList extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/

    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private intervalMs: number = 1000 * 3;

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    // 初期化されたか
    private get isformatted(): boolean {
        return sessionModule.getTrainingData === null;
    }

    // KC列挙状態
    private get listedState(): number {
        return sessionModule.getListed;
    }

    // KC列挙が終了したか
    private get isListed(): boolean {
        return this.listedState === SC.Flag.Process.DONE;
    }
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        if (this.listedState === SC.Flag.Process.TODO) {
            // フラグ更新（KC列挙 実施中）
            sessionModule.SET_LISTED(SC.Flag.Process.DOING);

            this.getKcList();
        }
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    private async getKcList() {
        // 学習開始
        const createResult = await sessionModule.startCreateModel();

        // 学習開始失敗時はここで終了
        if (!createResult) {
            this.goBack();
            return;
        }

        // 学習状況確認
        // 定期的に呼ばれる処理
        const pooling = (milliSeconds: number) => {
            return new Promise((resolve, reject) => {
                setTimeout(async () => {
                    resolve(await sessionModule.getModelCreationState());
                }, milliSeconds);
            });
        };

        // 定期的に呼ぶ処理
        while (true) {
            const status = await pooling(this.intervalMs);

            // 初期化されていれば処理終了
            if (this.isformatted) {
                return;
            }

            if (status == 'completed') break;
            if (status == 'error' || status == '') {
                this.goBack();
                return;
            }
        }

        // ナレッジチャンク一覧取得
        const kcListResult = await sessionModule.getKcListForModel();

        if (!kcListResult) {
            this.goBack();
            return;
        }

        // KC列挙への自動遷移
        sessionModule.SET_LISTED(SC.Flag.Process.DONE);
        sessionModule.SET_ROUTE_TRIALS(SC.Path.TRAIN_KC_MENU);
        this.$router.replace(sessionModule.getCurrentRouterViewTrials);
    }

    private goBack(): void {
        // フラグ更新（KC未列挙）
        sessionModule.SET_LISTED(SC.Flag.Process.TODO);

        // この画面が表示されている場合はひとつ前にもどる
        if (this.$route.path === SC.Path.TRAIN_DATA_GETTING_KC_LIST) {
            this.$router.go(-1);
        }
    }
}
